exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-cascader__suggestion-item {\n  font-size: 12px;\n}\n.el-cascader__empty-text {\n  margin: 10px;\n}\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/public/components/el-cascader/src/cascader.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB;AACD;EACE,aAAa;CACd","file":"cascader.vue","sourcesContent":["\n.el-cascader__suggestion-item {\n  font-size: 12px;\n}\n.el-cascader__empty-text {\n  margin: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1423ab02","scoped":false,"hasInlineConfig":false}!./node_modules/fast-sass-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/public/components/el-cascader/src/cascader.vue
// module id = eW7R
// module chunks = 4